// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__mrVSv","true":"TableRow_true__LKymf","rowItem":"TableRow_rowItem__QsNUf","isHeader":"TableRow_isHeader__o3ROZ"};